import { render, staticRenderFns } from "./Normal.vue?vue&type=template&id=3cdf2f22&"
import script from "./Normal.vue?vue&type=script&lang=ts&"
export * from "./Normal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports